import { callApi, IApiErrorResponse } from '@/api/callApi';
import { API_ENDPOINT, API_URL } from '@/api/constant';
import DetailCard, { ICardDetail } from '@/components/common/DetailCard';
import ViewDocumentModal from '@/components/common/ViewDocumentModal';
import Layout from '@/components/Layout/Layout';
import FullPageLoader from '@/components/loader/FullPageLoader';
import BackButton from '@/components/ui/BackButton';
import { IEmployeeResponse } from '@/interfaces/employee.model';
import { IDocument, IUser } from '@/interfaces/user.model';
import {
    capitalizeFirstLetter,
    genderHandler,
    showToastNotification,
} from '@/utility/helper';
import moment from 'moment';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
const DetailEmployee = () => {
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [isViewModal, setIsViewModal] = useState<boolean>(false);
    const [selectedDocument, setSelectedDocument] =
        useState<null | Partial<IDocument>>(null);
    const [employeeDetail, setEmployeeDetail] = useState<IUser | null>(null);
    const { id } = useParams();
    const toggleModal = () => {
        setIsViewModal(!isViewModal);
    };
    const employeeStatusHandler = (value: string) => {
        if (value === 'current') {
            return (
                <td>
                    <span className="badge bg-green-25 fw-normal rounded-pill">
                        Current
                    </span>
                </td>
            );
        } else if (value === 'exEmployee') {
            return (
                <td>
                    <span className="badge bg-yellow-25 fw-normal rounded-pill">
                        Ex-Employee
                    </span>
                </td>
            );
        }
    };
    const bacisDetails: ICardDetail[] = [
        { label: 'Employee Code', value: employeeDetail?.employeeCode ?? '-' },
        { label: 'Name', value: capitalizeFirstLetter(employeeDetail?.name ?? "-") },
        { label: 'Gender', value: genderHandler(employeeDetail?.gender ?? 0) },
        { label: 'Email', value: employeeDetail?.email },
        { label: 'Contact', value: employeeDetail?.phone },
        {
            label: 'Date of Birth',
            value: employeeDetail?.dob
                ? moment(employeeDetail?.dob).format('DD-MMM-YYYY')
                : '--',
        },
        // {
        //     label: ' Father Name',
        //     value: employeeDetail?.userdetail?.fatherName ?? '-',
        // },
        // {
        //     label: '    Mother Name',
        //     value: employeeDetail?.userdetail?.motherName ?? '-',
        // },
        // {
        //     label: 'Emergency Person',
        //     value: employeeDetail?.userdetail?.ecpName ?? '-',
        // },
        // {
        //     label: 'Emergency Contact',
        //     value: employeeDetail?.userdetail?.ecpPhone ?? '-',
        // },
        {
            label: '  Joining Date',
            value: employeeDetail?.dob
                ? moment(employeeDetail?.joiningDate).format('DD-MMM-YYYY')
                : '--',
        },
        // { label: '   Blood Group', value: employeeDetail?.bloodGroup },
        {
            label: 'Status',
            value: employeeStatusHandler(employeeDetail?.status || '') ?? '-',
        },
        {
            label: '    Marital Status',
            value: employeeDetail?.isMarried ? 'Married' : 'Unmarried',
        },
        // { label: '  Skill Type', value: employeeDetail?.skillType ?? '-' },
    ];
    const permission: ICardDetail[] = [
        { label: 'Company', value: employeeDetail?.Company?.name },
        { label: 'Office ', value: employeeDetail?.site?.name },
        { label: 'Department ', value: employeeDetail?.department?.name },
        { label: 'Designation', value: employeeDetail?.designation?.name },
        { label: 'Shift', value: employeeDetail?.Shift?.shiftName },
    ];
    // const advanceDetails: ICardDetail[] = [
    //   { label: 'UAN No', value: employeeDetail?.userdetail?.uanNumber },
    //     {
    //         label: 'Aadhar Card No',
    //         value: employeeDetail?.userdetail?.aadharNumber,
    //     },
    //     { label: 'PAN Number', value: employeeDetail?.userdetail?.panNumber },
    //     { label: 'ESIC Number', value: employeeDetail?.userdetail?.esicNumber },
    //     {
    //         label: 'Insurance Number',
    //         value: employeeDetail?.userdetail?.insuranceNumber,
    //     },
    //     { label: 'PF Number', value: employeeDetail?.userdetail?.pfNumber },
    //     {
    //         label: 'Driving License No.',
    //         value: employeeDetail?.userdetail?.drivingLicenseNumber,
    //     },
    // ];
    // const currentAddress: ICardDetail[] = [
    //     { label: 'Address', value: employeeDetail?.userdetail?.address },
    //     {
    //         label: 'State',
    //         value: employeeDetail?.userdetail?.state,
    //     },
    //     { label: 'City', value: employeeDetail?.userdetail?.city },
    //     { label: 'Post Code', value: employeeDetail?.userdetail?.pinCode },
    // ];
    // const permanentAddress: ICardDetail[] = [
    //     {
    //         label: 'Address',
    //         value: employeeDetail?.userdetail?.permanentAddress,
    //     },
    //     {
    //         label: 'State',
    //         value: employeeDetail?.userdetail?.permanentState,
    //     },
    //     { label: 'City', value: employeeDetail?.userdetail?.permanentCity },
    //     {
    //         label: 'Post Code',
    //         value: employeeDetail?.userdetail?.permanentPinCode,
    //     },
    // ];
    // const bankDetails: ICardDetail[] = [
    //     {
    //         label: 'Account Holder Name',
    //         value: employeeDetail?.userdetail?.accountHolderName,
    //     },
    //     {
    //         label: 'Account Number',
    //         value: employeeDetail?.userdetail?.accountNumber,
    //     },
    //     {
    //         label: 'IFSC/RTGS Code',
    //         value: employeeDetail?.userdetail?.ifscCode,
    //     },
    //     { label: 'Bank Name', value: employeeDetail?.userdetail?.bankName },
    //     {
    //         label: 'Branch Address',
    //         value: employeeDetail?.userdetail?.branchAddress,
    //     },
    // ];
    // const nomineeDetails: ICardDetail[] = [
    //     {
    //         label: 'Relation Type',
    //         value: employeeDetail?.userdetail?.nomineeRelation,
    //     },
    //     {
    //         label: 'Name ',
    //         value: employeeDetail?.userdetail?.nomineeName,
    //     },
    //     {
    //         label: 'Phone No.',
    //         value: employeeDetail?.userdetail?.nomineePhone,
    //     },
    //     {
    //         label: 'Date of Birth',
    //         value:
    //             employeeDetail?.userdetail?.nomineeDob &&
    //             moment(employeeDetail?.userdetail?.nomineeDob).format('DD-MMM-YYYY'),
    //     },
    // ];

    const getEmployeeDetail = async () => {
        setIsLoading(true);
        try {
            const response: IEmployeeResponse = await callApi(
                API_URL + API_ENDPOINT.getProfile + `?userId=${id}`,
                {
                    method: 'GET',
                },
            );
            if (response?.status) {
                setEmployeeDetail(response?.data);
            }
        } catch (error) {
            if (error && typeof error === 'object' && 'message' in error) {
                showToastNotification('danger', (error as IApiErrorResponse).message);
            } else {
                showToastNotification('danger', 'Something went wrong');
            }
        } finally {
            setIsLoading(false);
        }
    };
    useEffect(() => {
        if (id) {
            getEmployeeDetail();
        }
    }, [id]);
    const handleDocumentClick = (doc: IDocument | string) => {
        const url = typeof doc == 'string' ? doc : doc?.url;
        const docUrl = {
            url,
        };

        setSelectedDocument(docUrl);
        setIsViewModal(true);
    };
    return (
        <>
            <Layout>
                {isLoading ? (
                    <FullPageLoader />
                ) : (
                    <div className="content container-fluid">
                        <BackButton isDetail={true} label="Employee Detail" />
                        <div className="row">
                            <div className="col-12 col-lg-12">
                                <DetailCard
                                    title="Personal Details"
                                    cardDetails={bacisDetails}
                                    handleDocumentClick={handleDocumentClick}
                                    profile={
                                        employeeDetail?.profilePhoto || '/assets/img/employee.svg'
                                    }
                                />
                            </div>

                            <div className="col-12 col-lg-12">
                                <DetailCard title="Permission" cardDetails={permission} />
                            </div>
                            {/* <div className="col-12 col-lg-12">
                                <DetailCard
                                    title="Advance Details"
                                    cardDetails={advanceDetails}
                                />
                            </div> */}
                            {/* <div className="col-12 col-lg-6">
                                <DetailCard
                                    title="Current Address"
                                    cardDetails={currentAddress}
                                />
                            </div> */}
                            {/* <div className="col-12 col-lg-6">
                                <DetailCard
                                    title="Permanent Address"
                                    cardDetails={permanentAddress}
                                />
                            </div> */}
                            {/* <div className="col-12 col-lg-6">
                                <DetailCard title="Bank Details" cardDetails={bankDetails} />
                            </div> */}
                            {/* <div className="col-12 col-lg-6">
                                <div className="card manage-user-list">
                                    <div className="card-body">
                                        <div className="d-flex align-items-center justify-content-between border-bottom mb-3">
                                            <h4 className="d-flex align-items-center mb-4">
                                                Previous Work
                                            </h4>
                                        </div>
                                        {employeeDetail?.previousworks &&
                                            employeeDetail?.previousworks?.length > 0 ? (
                                            employeeDetail?.previousworks?.map((item, index) => {
                                                return (
                                                    <ul
                                                        key={index}
                                                        className="row list-unstyled border border-1 rounded"
                                                    >
                                                        <li className="col-12 col-md-6 col-lg-4">
                                                            <div>
                                                                <span className="text-muted fs-5 d-block">
                                                                    Company Name :-
                                                                </span>
                                                                {item?.companyName}
                                                            </div>
                                                        </li>
                                                        <li className="col-12 col-md-6 col-lg-4">
                                                            <div>
                                                                <span className="text-muted fs-5 d-block">
                                                                    Designation Name :-
                                                                </span>
                                                                {item?.designationName}
                                                            </div>
                                                        </li>
                                                        <li className="col-12 col-md-6 col-lg-4 fs-4">
                                                            <div>
                                                                <span className="text-muted fs-5 d-block">
                                                                    Duration:-
                                                                </span>
                                                                <span className="fw-medium fs-5">
                                                                    {`${moment(item?.fromDate).format(
                                                                        'DD-MMM-YYYY',
                                                                    )} To 
                                 ${item?.toDate
                                                                            ? moment(item?.toDate).format(
                                                                                'DD-MMM-YYYY',
                                                                            )
                                                                            : 'Currently Working'
                                                                        }`}
                                                                </span>
                                                            </div>
                                                            {calculateDuration(item?.fromDate, item?.toDate)}
                                                        </li>
                                                    </ul>
                                                );
                                            })
                                        ) : (
                                            <div className="d-flex justify-content-center">
                                                <h4>No work detail found</h4>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div> */}
                            {/* <div className="col-12 col-lg-4">
                                <DetailCard
                                    title="Documents"
                                    documents={employeeDetail?.documents}
                                    handleDocumentClick={handleDocumentClick}
                                />
                            </div> */}
                            {/* <div className="col-12 col-lg-8">
                                <DetailCard
                                    title="Nominee Details"
                                    cardDetails={nomineeDetails}
                                    handleDocumentClick={handleDocumentClick}
                                />
                            </div> */}
                        </div>
                    </div>
                )}
            </Layout>
            <ViewDocumentModal
                isOpen={isViewModal}
                toggle={toggleModal}
                selectedDocument={selectedDocument}
            />
        </>
    );
};
export default DetailEmployee;
